<template>
    <div class="p-2 p-md-3 d-flex justify-content-center align-items-center bg-color-white box-shadow-large">
        <i class="mx-3 fas fa-fw fa-search font-size-h4"></i>

        <input type="search"
               class="main-search-field"
               :name="inputName"
               :placeholder="inputPlaceholder"
               required
               v-model="searchValue"
               @input="searchValueChanged">
    </div>
</template>

<script>
    import SearchByFilters from '../MrMovie/SearchByFilters';

    export default {
        props: {
            // 'movie_cinema', 'movie', or 'cinema'
            searchType: {
                type: String,
                required: true,
            },
            inputName: {
                type: String,
                default: 'movie_cinema_search',
            },
            inputValue: {
                type: String,
                default: null,
            },
            inputPlaceholder: {
                type: String,
                default: 'Zoek naar film, serie of bioscoop',
            },
            searchByFilters: null
        },
        data() {
            return {
                searchValue: this.inputValue,
                cinemaSearchByFilters: null,
            };
        },
        mounted() {
            // Create the search object, for listening to updates and getting data from
            if (this.searchByFilters === null) {
                if (this.searchType === 'movie' || this.searchType === 'movie_cinema') {
                    this.searchByFilters = new SearchByFilters('movie_filter', '/ajax/movies');
                } else if (this.searchType === 'cinema') {
                    this.searchByFilters = new SearchByFilters('cinema_filter', '/ajax/cinemas');
                }

                this.searchByFilters.listenForChangeEvents();
            }

            // If a value is set, set is as a filter value
            if (this.inputValue !== null) {
                if (this.searchType === 'movie' || this.searchType === 'movie_cinema') {
                    this.searchByFilters.setValues('title', this.inputValue);
                } else if (this.searchType === 'cinema') {
                    this.searchByFilters.setValues('name', this.inputValue);
                }
            }

            // A separate listener for cinema search
            if (this.searchType === 'movie_cinema') {
                this.cinemaSearchByFilters = new SearchByFilters('cinema_filter', '/ajax/cinemas');
                this.cinemaSearchByFilters.listenForChangeEvents();

                // If a value is set, set is as a filter value
                if (this.inputValue !== null) {
                    this.cinemaSearchByFilters.setValues('name', this.inputValue);
                }
            }

            $(document).on('vue-ready', () => {
                // Trigger the search value change event
                if (this.inputValue !== null) {
                    this.searchValue = this.inputValue;
                    this.searchValueChanged();
                }
            })
        },
        methods: {
            /**
             * Emit the search value as a filter for searching
             * @return {void}
             */
            searchValueChanged() {
                // Emit the search value for movie search
                if (this.searchType === 'movie' || this.searchType === 'movie_cinema') {
                    VueEvents.$emit('movie_filter:changed', {
                        type: 'title',
                        values: this.searchValue,
                    });
                }

                // See if the minimum amount of characters is filled in
                const validSearchValue = (this.searchValue.length > 0);
                if (this.searchType === 'movie_cinema') {
                    // Show/hide the titles, based on the length of the search value
                    VueEvents.$emit('show_home_title_movies', validSearchValue);
                    VueEvents.$emit('show_home_title_cinemas', validSearchValue);
                    VueEvents.$emit('show_cinema_cards', validSearchValue);
                }

                // Emit the search value for cinema search
                if (this.searchType === 'cinema' || this.searchType === 'movie_cinema') {
                    VueEvents.$emit('cinema_filter:changed', {
                        type: 'name',
                        values: this.searchValue,
                    });
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/LegacyHeaderSearch.vue